import { useEffect, useState } from "react";
import { Lightning, Pulse, ArrowsClockwise } from "@phosphor-icons/react";
import useSWR from "swr";
import { getHealth, triggerScan, getScanRuns } from "@/lib/api";
import { Pill } from "@/components/common/Pill";
import { NAV } from "@/constants/testIds";
import { toast } from "sonner";

export const TopBar = () => {
  const { data: health } = useSWR("/health", getHealth, { refreshInterval: 15000 });
  const { data: runs, mutate: mutateRuns } = useSWR("/scan/runs", () => getScanRuns(1), {
    refreshInterval: 15000,
  });
  const [triggering, setTriggering] = useState(false);

  const lastRun = runs?.[0];
  const scanning = lastRun?.status === "running";

  useEffect(() => {
    if (!scanning) setTriggering(false);
  }, [scanning]);

  const handleScan = async () => {
    try {
      setTriggering(true);
      const r = await triggerScan();
      toast.success(r.message || "Scan triggered");
      mutateRuns();
    } catch (e) {
      toast.error("Failed to trigger scan");
      setTriggering(false);
    }
  };

  const schedTone = health?.scheduler === "running" ? "success" : "error";
  const apiTone = health?.weex_public_api === "ok" ? "success" : "error";

  return (
    <header className="sticky top-0 z-40 backdrop-blur-xl bg-[#eef2f9]/85 border-b border-slate-200/70">
      <div className="flex items-center justify-between px-4 md:px-6 py-3 gap-4">
        <div className="flex items-center gap-2">
          <span className="text-[10px] tracking-[0.2em] uppercase text-slate-500 hidden md:inline">
            Live Scanner
          </span>
          <span className="md:hidden font-heading font-black text-slate-900">
            WEEX·SIGNALS
          </span>
        </div>

        <div className="flex items-center gap-2">
          <Pill tone={schedTone} data-testid={NAV.schedulerPill}>
            <Pulse size={10} weight="fill" className={schedTone === "success" ? "pulse-dot" : ""} />
            SCHED · {health?.scheduler || "…"}
          </Pill>
          <Pill tone={apiTone} data-testid={NAV.healthPill}>
            WEEX · {health?.weex_public_api || "…"}
          </Pill>
          <button
            data-testid={NAV.runScanBtn}
            onClick={handleScan}
            disabled={triggering || scanning}
            className="inline-flex items-center gap-2 bg-[#2563eb] hover:bg-[#1d4ed8] disabled:opacity-50 disabled:cursor-not-allowed text-white font-bold text-xs tracking-wider uppercase px-3 py-2 rounded-sm transition-all"
          >
            {scanning ? (
              <ArrowsClockwise size={14} weight="bold" className="animate-spin" />
            ) : (
              <Lightning size={14} weight="fill" />
            )}
            {scanning ? "Scanning" : "Run Scan"}
          </button>
        </div>
      </div>
    </header>
  );
};
